<template>
    <span>
        <svg
            width="9"
            height="9"
            viewBox="0 0 9 9"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M9 4.49999C6.92305 5.27295 5.27295 6.92305 4.49998 9C3.72702 6.92306 2.07693 5.27297 0 4.50001C2.07693 3.72704 3.72703 2.07694 4.49998 0C5.27295 2.07694 6.92306 3.72704 9 4.49999Z"
                fill="#4EC6D4"
            />
        </svg>
    </span>
</template>
